import { debounce } from 'essential-utils';
import React from 'react';
import { useMounted } from '../../hooks';
const SCROLL_THRESHOLD = 20;
const MINIMUM_BATCH_SIZE = 70;
export function usePageSize(apiRef, initialState, rowHeight) {
    const mounted = useMounted();
    const [gridHeight, setGridHeight] = React.useState(apiRef?.current?.getRootDimensions?.().viewportInnerSize.height);
    const initialStatePageSize = initialState?.pagination?.paginationModel?.pageSize;
    const [pageSize, setPageSize] = React.useState(initialStatePageSize ?? 0);
    React.useLayoutEffect(() => {
        const handleViewportSizeChange = debounce(({ height }) => {
            if (!mounted.current) {
                return;
            }
            if (!gridHeight ||
                height > gridHeight + SCROLL_THRESHOLD ||
                height < gridHeight - SCROLL_THRESHOLD) {
                setGridHeight(height);
                setPageSize(Math.max(MINIMUM_BATCH_SIZE, Math.floor(height / rowHeight) * 3));
            }
        }, 48);
        const unsubscribe = apiRef?.current?.subscribeEvent('viewportInnerSizeChange', handleViewportSizeChange);
        return () => {
            handleViewportSizeChange.cancel();
            unsubscribe?.();
        };
    }, [apiRef, gridHeight, mounted, rowHeight]);
    React.useEffect(() => {
        if (initialStatePageSize) {
            setPageSize(initialStatePageSize);
        }
    }, [initialStatePageSize]);
    return { pageSize, gridHeight };
}
